import { OptionFilter } from '.';
import React, { memo, useMemo } from 'react';
import { UpdateQueryParams, useTags } from '@hooks';

export type TagFilterQueryParams = {
	filterByTags?: string;
};
export interface TagFilterProps {
	onChange: UpdateQueryParams<TagFilterQueryParams>;
}

export const TagFilter: React.FC<TagFilterProps> = memo(({ onChange }) => {
	const tags = useTags();

	const sortedTags = useMemo(
		() =>
			tags.map((tag) => ({
				label: tag.name,
				value: tag.id
			})),
		[ tags ]
	);

	return (
		<OptionFilter
			onChange={ (filterByTags) => onChange({ filterByTags: filterByTags as string }) }
			options={ sortedTags }
			placeholder='Filter by Tag' />
	);
});
